/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      this.$section = $section;
      this.$sliderEl = $section.find('[data-slider]');
      this.$sliderArrows = $section.find('[data-featured-collection-arrows]');
      this.sliderInstance = null;
      this.resizeHandler = this.onResize.bind(this);

      this.updateSliderState();
      $(window).on('resize.featuredCollection', this.resizeHandler);
    },
    shouldUseDesktopSlider: function () {
      return this.collection_style == 'slider' && this.enable_desktop_slider === true && window.innerWidth > 798;
    },
    createSlider: function () {
      if (!this.$sliderEl.length || this.sliderInstance) {
        return;
      }

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      };

      this.sliderInstance = this.$sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: false,
        contain: true,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
        initialIndex: 0,
        arrowShape: 'M7.77454 0.86377L0.863823 7.77448L7.77454 14.6852'
      });

      this.$sliderEl.on('settle.flickity', function () {
        $(this).flickity('resize');
      });

      this.moveSliderArrows();
    },
    moveSliderArrows: function () {
      if (!this.$sliderArrows.length) {
        return;
      }

      const $buttons = this.$section.find('.flickity-prev-next-button');

      if ($buttons.length) {
        this.$sliderArrows.append($buttons);
        this.updateSliderButtonIcons($buttons);
      }
    },
    updateSliderButtonIcons: function ($buttons) {
      const sliderButtonSvg = `
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <path d="M17.2765 6.91064L10.3658 13.8214L17.2765 20.7321" stroke="currentColor" stroke-width="1.72768" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      `;

      $buttons.each(function () {
        $(this).find('.flickity-button-icon').remove();
        $(this).html(sliderButtonSvg);
      });
    },
    destroySlider: function () {
      if (!this.$sliderEl.length || !this.sliderInstance) {
        return;
      }

      this.$sliderEl.off('settle.flickity');
      this.$sliderEl.flickity('destroy');
      this.sliderInstance = null;
    },
    updateSliderState: function () {
      if (this.shouldUseDesktopSlider()) {
        this.createSlider();
      } else {
        this.destroySlider();
      }
    },
    onResize: function () {
      this.updateSliderState();

      if (this.sliderInstance) {
        this.moveSliderArrows();
      }
    },
    unload: function () {
      $(window).off('resize.featuredCollection', this.resizeHandler);
      this.destroySlider();
    }
  }

  /******/
})()
  ;
